// Return the MTO CTA button if present
const getMtoButton = (productId) => document.querySelector(".product-" + productId + ' [data-cta-type="mto"]');

// Find the product form associated with the MTO button
export const findProductForm = (productId) => {
    const mtoButton = getMtoButton(productId);
    if (!mtoButton) return null;
    return mtoButton.closest('form[action*="/cart/add"]') || null;
};

/**
 * Add MTO attributes to the product form
 */
const createHiddenInput = (name, value, id) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    if (id) input.id = id;
    return input;
};

export const addMTOAttributes = (productId) => {
    const mtoButton = getMtoButton(productId);
    if (!mtoButton) return;

    const form = findProductForm(productId);
    if (!form) return;

    removeMTOAttributes(productId);

    const shippingTime = mtoButton.dataset.mtoShippingTime || "";

    form.appendChild(createHiddenInput("properties[Made To Order]", `Ships in ${shippingTime}`, "made-to-order-prop"));
    form.appendChild(createHiddenInput("properties[_warning_made_to_order_info]", "true", "made-to-order-attr"));
};

/**
 * Remove MTO attributes from the product form
 */
export const removeMTOAttributes = (productId) => {
    const form = findProductForm(productId);
    if (!form) return;

    form.querySelector("#made-to-order-prop")?.remove();
    form.querySelector("#made-to-order-attr")?.remove();
};

export const checkMTOInventory = (productId, variant) => {
    const mtoButton = getMtoButton(productId);
    if (!mtoButton || !variant) return false;
    const isOutOfStockOrZero = typeof variant.inventory_quantity === "number" ? variant.inventory_quantity <= 0 : false;
    const allowsBackorder = variant.inventory_policy === "continue";

    return isOutOfStockOrZero && allowsBackorder;
};
